import { Link } from 'react-router-dom';
import { categories, mainSiteUrl } from '@/mocks/categories';

const guideLinks = [
  { label: 'Complete Guide 2026', path: '/acbuy-spreadsheet-guide' },
  { label: 'Safety Tips', path: '/acbuy-spreadsheet-guide#safety' },
  { label: 'Getting Started', path: '/acbuy-spreadsheet-guide#get-started' },
];

const infoLinks = [
  { label: 'FAQ', path: '/#faq' },
  { label: 'About Us', path: '/#why' },
  { label: 'Contact', path: '/#cta' },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-background-200/70">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-16">
        <div className="relative">
          <div className="absolute -top-6 -left-4 w-12 h-12 bg-primary-500/10 rounded-lg rotate-[15deg] hidden lg:block" />
          <div className="absolute -top-6 -right-4 w-12 h-12 bg-accent-500/10 rounded-lg -rotate-[15deg] hidden lg:block" />

          <div className="relative bg-background-50 rounded-2xl p-8 md:p-12">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
              <div className="md:col-span-1">
                <Link to="/" className="inline-block cursor-pointer">
                  <span className="text-xl font-heading font-bold text-foreground-950">
                    ACBuy<span className="text-primary-500">Spreadsheet</span>
                  </span>
                </Link>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                  The ultimate ACBuy spreadsheet directory — trusted by thousands for curated product links, buying guides, and shopping resources updated weekly.
                </p>
              </div>

              <div>
                <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
                  Categories
                </h4>
                <div className="flex flex-col gap-2.5">
                  {categories.slice(0, 6).map((cat) => (
                    <a
                      key={cat.name}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {cat.name}
                    </a>
                  ))}
                </div>
              </div>

              <div>
                <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
                  Guides & More
                </h4>
                <div className="flex flex-col gap-2.5">
                  {guideLinks.map((link) => (
                    <Link
                      key={link.path}
                      to={link.path}
                      className="text-sm text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  ))}
                  {categories.slice(6).map((cat) => (
                    <a
                      key={cat.name}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {cat.name}
                    </a>
                  ))}
                </div>
              </div>

              <div>
                <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
                  Info
                </h4>
                <div className="flex flex-col gap-2.5">
                  {infoLinks.map((link) => (
                    <Link
                      key={link.path}
                      to={link.path}
                      className="text-sm text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  ))}
                  <a
                    href={mainSiteUrl}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm font-semibold text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    KASpreadsheet →
                  </a>
                </div>
              </div>
            </div>

            <div className="mt-12 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-foreground-500">
                &copy; 2026 ACBuySpreadsheet. All rights reserved. Updated June 2026.
              </p>
              <div className="flex items-center gap-4">
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
                >
                  Privacy Policy
                </a>
                <span className="text-foreground-300">|</span>
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
                >
                  Disclaimer
                </a>
                <span className="text-foreground-300">|</span>
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
                >
                  Terms
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}